import { useEffect, useRef, useCallback, useMemo, useState } from "react";
import { useStorage, StorageType } from "@/features/projects/hooks/use-storage";

interface UseProjectPhaseParams {
  projectId: number | null;
}

export function usePhase({ projectId }: UseProjectPhaseParams) {
  const { get, set, remove } = useStorage(StorageType.Session);

  // ✅ Evitar inicializar `useStorage` si `projectId` es `null`
  const storagePhaseKey = useMemo(
    () => (projectId !== null ? `p[${projectId}]-active-phase` : "__ignore__"),
    [projectId]
  );

  const [selectedPhase, setSelectedPhase] = useState("custom_problem_observation");
  const previousPhaseRef = useRef<string | null>(null);

  // 📌 Recuperar el valor almacenado en sessionStorage cuando `projectId` sea válido
  useEffect(() => {
    if (projectId !== null && storagePhaseKey) {
      const cachedPhase = get<string>(storagePhaseKey);
      if (cachedPhase) {
        setSelectedPhase(cachedPhase);
      }
    }
  }, [projectId, storagePhaseKey, get]);

  // 📌 Inicializar `previousPhaseRef` cuando `selectedPhase` cambia
  useEffect(() => {
    if (previousPhaseRef.current === null) {
      previousPhaseRef.current = selectedPhase;
    }
  }, [selectedPhase]);

  // ✅ Función para cambiar de fase
  // const setSelectedPhase = useCallback(
  //   (newPhase: string) => {
  //     if (projectId === null) return; // 🚨 Evitar actualizar si no hay un `projectId` válido

  //     setSelectedPhaseStorage((currentPhase) => {
  //       if (currentPhase !== newPhase) {
  //         const previousPhase = previousPhaseRef.current;
  //         previousPhaseRef.current = currentPhase;

  //         // 🔥 Emitir evento global de cambio de fase
  //         if (typeof window !== "undefined") {
  //           window.dispatchEvent(
  //             new CustomEvent("phaseChange", {
  //               detail: { previousPhase, currentPhase: newPhase, projectId },
  //             })
  //           );
  //         }

  //         return newPhase;
  //       }
  //       return currentPhase; // No cambia si es la misma fase
  //     });
  //   },
  //   [projectId, setSelectedPhaseStorage]
  // );

  return { selectedPhase, setSelectedPhase };
}
